import { connect } from "react-redux";
import { IonApp } from "@ionic/react";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./theme/global.scss";
import "./theme/styles.css";

import { getUsers, storeUserInfo } from "./services/users";

import { ImageUploadContextProvider } from "react-capacitor-firebase-image-upload";
import RoutingSystem from "./routes";
//import { getStorage, ref } from "firebase/storage";

import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { useEffect } from "react";
import { getCurrentUser, logout } from "./services/auth";
import { setUser } from "./services/users";

//TODO this firebase storage section needs updating to v9 API. May require changing the file upload plugin.
//https://www.npmjs.com/package/react-capacitor-firebase-image-upload
const firebaseConfig = {
	apiKey: "AIzaSyBizIVShq-oqNh7EntXqcS9sC7wYPLnbm0",
	authDomain: "waiora-tamariki.firebaseapp.com",
	projectId: "waiora-tamariki",
	storageBucket: "waiora-tamariki.appspot.com",
	messagingSenderId: "583506478446",
	appId: "1:583506478446:web:530107b7c3ea08e5c36d7f",
	measurementId: "G-F0028F64YD",
};
firebase.initializeApp(firebaseConfig);
// const storage = getStorage();
// const storageRef = ref(storage, "images");
const storageRef = firebase.storage().ref();

interface props {
	userDetails: any;
	setUser: any;
	getUsers: any;
	storeUserInfo: any;
}

const App: React.FC<props> = ({
	userDetails,
	setUser,
	getUsers,
	storeUserInfo,
}) => {
	useEffect(() => {
		getCurrentUser().then((user: any) => {
			if (user) {
				setUser(user);
			} else logout();
		});
	}, []);

	useEffect(() => {
		if (userDetails.isAdmin) {
			//console.log("isAdmin");
			getUsers();
		} else if (userDetails.id) {
      console.log(userDetails.id)
			storeUserInfo(userDetails.uid);
		}
	}, [userDetails]);

	return (
		<IonApp>
			<ImageUploadContextProvider firebaseStorageRef={storageRef}>
				<RoutingSystem />
			</ImageUploadContextProvider>
		</IonApp>
	);
};

const mapDispatchToProps = {
	setUser,
	getUsers,
	storeUserInfo,
};

const mapStateToProps = (state: any) => ({
	userDetails: state.user.userDetails,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
